import { Component, OnInit, ViewChild } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { Locker } from 'src/app/models/locker.model';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { lockers } from 'src/app/resources/lockers';
import { DialogContentBase, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { HorizontalAlign } from '@progress/kendo-angular-layout';
import { SharingService } from 'src/app/services/sharing.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { Modulo } from 'src/app/models/modulo.model';
import { Router } from '@angular/router';
import { Compartimento } from 'src/app/models/compartimento.model';
import { CompartmentFormComponent } from '../compartment-form/compartment-form.component';

@Component({
    selector: 'app-lockers-edit-component',
    templateUrl: './lockers-edit.component.html'
})
export class LockersEditComponent extends DialogContentBase implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    public hAlign: HorizontalAlign = "start";
    public gridData: Locker[] = lockers;
    public gridView: any[] = [];
    public locker: Locker = {
        id: 0,
        nomeLocal: '',
        refLocal: 0,
        refModeloArmario: 0,
        nomeModeloArmario: '',
        numeroDeSerie: '',
        nome: '',
        dimensaoTotal: '',
        numeroUtilDeCacifos: '',
        modulos: []
    };
    public mySelection: string[] = [];
    public modulos: Modulo[] = [];
    public customMsgService: CustomMessagesService;

    constructor(private router: Router, private sharingService: SharingService, public msgService: MessageService, private dialogService: DialogService, public override dialog: DialogRef, private api: ApiService) {
        super(dialog);
        this.customMsgService = this.msgService as CustomMessagesService;
    }

    backHome() {
        this.router.navigate(['/lockers']);
    }

    load() {
        this.api
            .getRequest<BaseHttpResponse<Modulo[]>>("Armario/GetConfiguracaoModulosArmario?idArmario=" + this.locker?.id)
            .then((data) => {
                this.modulos = data.value;
            })
            .catch((err) => { });
    }

    public ngOnInit(): void {
        this.locker = this.sharingService.sharingValue;
        this.load();
        this.gridView = this.gridData;
    }

    // Mensagem com a informação do cacifo
    public getTranslatedText(c: Compartimento): string {
        var inibido = this.customMsgService.translate('no');
        if (c.compartimentoEstado.bloqueado == true) {
            inibido = this.customMsgService.translate('yes');
        }
        var condicao = this.customMsgService.translate('ativa');
        if (c.compartimentoEstado.ferramentaBloqueada == true) {
            condicao = this.customMsgService.translate('bloqueada');
        }
        var text = ``;

        //casifo configurado
        if (c.refArtigo != null) {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}

${this.customMsgService.translate('artigo')}: ${c.descricaoArtigo}
${this.customMsgService.translate('codigoInterno')}: ${c.codigoInternoArtigo}
${this.customMsgService.translate('quantidadeDesejada')}: ${c.quantidadeDesejada}
${this.customMsgService.translate('quantidadeAlertaDeStock')}: ${c.quantidadeAlertaStock}`;
        }
        else {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}`;
        }
        return text;
    }

    public getText(c: Compartimento): string {
        var text = ``;
        if (c.refArtigo != null) {
            text = `${c.descricaoArtigo.substring(0, 8)} (${c.quantidadeDesejada} un.)`;
        }
        else {
            text = ``;
        }
        return text;
    }

    //Janela de edição do cacifo
    public openEditCompartimento(c: Compartimento): void {
        this.sharingService.sharingValue = c;
        const dialogRef = this.dialogService.open({
            title: this.customMsgService.translate('configuracao') + " " + this.customMsgService.translate('cacifo') + " - " + c.nome,
            content: CompartmentFormComponent,
        });
    }

    btnDisabled(c: Compartimento): boolean {
        if (c.hmi == true) {
            return true;
        }
        else {
            return false;
        }
    }

    estadoBtn(c: Compartimento): string {
        if (c.hmi == true) {
            return "width: 60px; height: 20px; background-color: rgba(0, 0, 0, 0); color: #000000; border: none; outline: none;";
        }
        else {
            return "width: 20px; height: 20px;";
        }
    }
} 
